import { AbstractLayoutHandler, InjectableViewsAdapterProps, LayoutAdapter } from '@localstack/resources';

import { ReactElement, useMemo } from 'react';

import { useRoutes } from '@localstack/services';
import { EmulatorType } from '@localstack/types';
import { PATH_PREFIX_RESOURCES } from '@localstack/constants';

import { ResourceBrowserLayout, ResourceBrowserLayoutProps } from '~/layouts';

import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useAuthProvider } from '~/hooks/useAuthProvider';
import { useIsFreemiumHobbyCommercialMisuse } from '~/hooks/useIsFreemiumHobbyCommercialMisuse';
import { pricingRoute } from '~/util/pricing';

export const ResourceBrowserAdapter = ({ Component, routes, endpoint }: InjectableViewsAdapterProps): ReactElement => {
  const { goto } = useRoutes();
  const isFreemiumHobbyCommercialMisuse = useIsFreemiumHobbyCommercialMisuse();

  const PreBakedRBLayout = useMemo(() => {
    const Layout = (props: ResourceBrowserLayoutProps) => <ResourceBrowserLayout {...props} endpoint={endpoint} />;
    Layout.displayName = 'PreBakedRBLayout';
    return Layout;
  }, [endpoint]);

  return (
    <Component
      Layout={PreBakedRBLayout}
      routes={routes}
      clientOverrides={{ endpoint }}
      useAuthProvider={useAuthProvider}
      useFeatureFlags={useFeatureFlags}
      onFeatureUpgradeButtonClick={() => goto(pricingRoute([EmulatorType.AWS]))}
      isFreemiumHobbyCommercialMisuse={isFreemiumHobbyCommercialMisuse}
    />
  );
};

export class ResourceBrowserHandler extends AbstractLayoutHandler {
  public handle(route: string): LayoutAdapter {
    if (route.startsWith(PATH_PREFIX_RESOURCES)) {
      return ResourceBrowserAdapter;
    }
    return super.handle(route);
  }
}
